// <auto-generated>
// Generated from contracts/api-v1.json by scripts/contracts.mjs (npm run contracts:generate). Do not edit.
// contract-sha256: 49313e4bd5771d8d1479841e3747e66f560bd32662aa94da0e2577b6ad0f54f0
// </auto-generated>
/** The reads the contract marks `x-lureo-cache: none`: the backend never caches their answers, in any region. */
export const neverCachedReads = [
  '/api/v1/asset-types/{assetTypeUniqueId}/conversion',
  '/api/v1/cover-jobs/{jobUniqueId}',
  '/api/v1/external-content',
  '/api/v1/mcp-authorizations',
  '/api/v1/remote-config',
  '/api/v1/scene-pins/resolve',
  '/api/v1/scenes/{sceneUniqueId}/changes',
  '/api/v1/share-links/resolve',
  '/api/v1/storage-objects',
  '/api/v1/storage-objects/content',
  '/api/v1/storage-objects/{bucket}/{path}',
  '/api/v1/users/me',
  '/api/v1/users/me/bootstrap',
  '/api/v1/users/me/changes',
  '/api/v1/users/me/mcp-connections',
  '/api/v1/version',
] as const;
